import React from 'react'
import { useSelector} from 'react-redux'
import moment from 'moment';
import { Fragment} from 'react'
import classNames from 'classnames'
import _ from 'lodash'

let EventGroups = function(props){

  const event_groups = useSelector(state => state.event_groups)
  let event_groups_header = useSelector(state => state.event_groups_header).trim()

  const language = useSelector(state => state.language)

  const input_width = useSelector(state => state.input_width) ? useSelector(state => state.input_width) : "8"
  const label_width = useSelector(state => state.label_width) ? useSelector(state => state.label_width) : "3"
  return (
    <Fragment>
      {event_groups == {} && event_groups_header && 
        <div dangerouslySetInnerHTML={{ __html: event_groups_header ? event_groups_header : ""}}></div>
      }
      {_.map(event_groups, (data, id) => {
        return(
          <Fragment key={"event_groups_div" + id}>
            {data.header_text && 
              <div className="row event-group-header">
                <div className={"optional-label col-md-" + label_width + ""}></div>
                <span className={"col-md-" + input_width + ""} key={"event_groups_text" + id}  dangerouslySetInnerHTML={{ __html: data.header_text}}></span>
              </div>
            }
            <div className="form-group event-group-content is-invalid" key={"col" +  "event_groups" + id}>
              <div className="row">
                <legend className={classNames("r-label col-form-label col-md-" + label_width, "pt-0")} dangerouslySetInnerHTML={{ __html: data.title}}></legend>
                <div className={"input-group flex-column col-md-" + input_width + " "}>
                    {_.map(data.events, (event, e_id) =>{
                      return(
                        <div key={"col" +  "event_groups" + "event" + e_id} className={"form-check mb-2 r-fc-" + event.id}>
                          <input name={"event_groups." + props.fieldType + ".group_" + data.id} id={"event_groups." + props.fieldType + ".group_" + data.id + e_id} 
                            ref={props.register} value={event.id} type={data.selection_mode? (data.selection_mode) : ("radio")} 
                            className={classNames("form-check-input", { "is-invalid": props.errors && props.errors.event_groups && props.errors.event_groups[props.fieldType] &&  props.errors.event_groups[props.fieldType]["group_" + data.id] })} disabled={event.limit && event.free_places <= 0} />
                          <label htmlFor={"event_groups." + props.fieldType + ".group_" + data.id + e_id} className={classNames("form-check-label", { sold: event.limit && event.free_places <= 0})}>
                            <div dangerouslySetInnerHTML={{ __html: event.alternative_title ? event.alternative_title : event.title}}/>
                            <div className="event-dates">
                              {(data.show_free_places &&  event.limit) &&
                                <div className="event-places">
                                  {language && language != "de" ? "Free Places: " : "Freie Plätze: "}
                                  {event.free_places <= 0 ? language && language == "de" ?  " - ausgebucht" : " - fully booked"  : event.free_places}
                                </div>
                              }
                              {data.show_event_begins_at && event.begins_at && (
                                <div className="event-date">
                                  {language && language != "de" ? "Start:" : "Beginn:"} {moment(event.begins_at).format('dd, DD.MM.YYYY HH:mm')} Uhr
                                </div>
                              )}
                              {data.show_event_ends_at && event.ends_at && (
                                <div className="event-date">
                                  {language && language != "de" ? "End:" : "Ende:"} {moment(event.ends_at).format('dd, DD.MM.YYYY HH:mm')} Uhr
                                </div>
                              )}
                            </div>
                          </label>
                        </div>
                      )
                    })}
                    {props.errors && props.errors.event_groups && props.errors.event_groups[props.fieldType] &&  props.errors.event_groups[props.fieldType]["group_" + data.id] && 
                      <div className="form-check invalid-feedback d-block">{props.errors.event_groups[props.fieldType]["group_" + data.id].message}</div>
                    }
                </div>
              </div>
              {data.footer_text && 
                <div className="row">
                  <div className={"col-md-" + label_width + " optional-label"}></div>
                  <span className={"col-md-" + input_width + ""} dangerouslySetInnerHTML={{ __html: data.footer_text}}></span>
                </div>
              }
            </div>
            
          </Fragment>
          )
      })}
    </Fragment>
  )
}
export default EventGroups;
